// src/pages/ServicesIncomeReport.js
import { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
//import axios from "axios";
import api from '../services/api';

export default function ServicesIncomeReport() {
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');

    const generate = async () => {
        const res = await api.post(
            "/reports/services-income",
            { from, to },
            { responseType: "blob" }
        );
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        // Open in new tab
        window.open(url, '_blank');

        // optional: revoke after a bit
        setTimeout(() => URL.revokeObjectURL(url), 10000);
    };

    return (
        <>
            <Typography variant="h5" gutterBottom sx={{ p: 2 }}>Services & Income</Typography>
            <Box
                sx={{
                    pt: 1,
                    px: 2,
                    // maxWidth: 600,
                    mx: "auto",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <TextField
                    label="From"
                    type="date"
                    value={from}
                    onChange={e => setFrom(e.target.value)}
                    // fullWidth
                    slotProps={{ inputLabel: { shrink: true } }}
                />
                <TextField
                    label="To"
                    type="date"
                    value={to}
                    onChange={e => setTo(e.target.value)}
                    // fullWidth
                    slotProps={{ inputLabel: { shrink: true } }}
                />
                <Button
                    variant="contained"
                    disabled={!from || !to}
                    onClick={generate}
                >
                    Run Report
                </Button>
            </Box>
        </>
    );
}